/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Student_1_NameInputs */

const en_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const es_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const de_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const zh_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const ar_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const fr_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const vi_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const sw_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const th_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const bs_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const ja_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const ko_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const pt_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const it_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const sv_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const nl_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const da_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const nb_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const fi_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const pl_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const ru_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const tr_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const hi_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const id_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const ms_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const cs_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const el_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const he_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const af_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

const hu_about_content_student_1_name = /** @type {(inputs: About_Content_Student_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mike McCoy`)
};

/**
* | output |
* | --- |
* | "Mike McCoy" |
*
* @param {About_Content_Student_1_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_student_1_name = /** @type {((inputs?: About_Content_Student_1_NameInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Student_1_NameInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_student_1_name(inputs)
	if (locale === "de") return de_about_content_student_1_name(inputs)
	if (locale === "zh") return zh_about_content_student_1_name(inputs)
	if (locale === "ar") return ar_about_content_student_1_name(inputs)
	if (locale === "fr") return fr_about_content_student_1_name(inputs)
	if (locale === "vi") return vi_about_content_student_1_name(inputs)
	if (locale === "sw") return sw_about_content_student_1_name(inputs)
	if (locale === "th") return th_about_content_student_1_name(inputs)
	if (locale === "bs") return bs_about_content_student_1_name(inputs)
	if (locale === "ja") return ja_about_content_student_1_name(inputs)
	if (locale === "ko") return ko_about_content_student_1_name(inputs)
	if (locale === "pt") return pt_about_content_student_1_name(inputs)
	if (locale === "it") return it_about_content_student_1_name(inputs)
	if (locale === "sv") return sv_about_content_student_1_name(inputs)
	if (locale === "nl") return nl_about_content_student_1_name(inputs)
	if (locale === "da") return da_about_content_student_1_name(inputs)
	if (locale === "nb") return nb_about_content_student_1_name(inputs)
	if (locale === "fi") return fi_about_content_student_1_name(inputs)
	if (locale === "pl") return pl_about_content_student_1_name(inputs)
	if (locale === "ru") return ru_about_content_student_1_name(inputs)
	if (locale === "tr") return tr_about_content_student_1_name(inputs)
	if (locale === "hi") return hi_about_content_student_1_name(inputs)
	if (locale === "id") return id_about_content_student_1_name(inputs)
	if (locale === "ms") return ms_about_content_student_1_name(inputs)
	if (locale === "cs") return cs_about_content_student_1_name(inputs)
	if (locale === "el") return el_about_content_student_1_name(inputs)
	if (locale === "he") return he_about_content_student_1_name(inputs)
	if (locale === "af") return af_about_content_student_1_name(inputs)
	if (locale === "hu") return hu_about_content_student_1_name(inputs)
	return en_about_content_student_1_name(inputs)
});